import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { rejectReservation, RejectReservationPayload, reservationRejected, reservationRejectFailed } from '../../actions/reservation/rejectReservation';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* rejectReservationSaga({ payload }: Action<RejectReservationPayload>) {
  const { reservation } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.rejectReservation, token, {
    reservationUuid: reservation.uuid,
    placeUuid: reservation.placeUuid,
    guestUuid: reservation.guest.uuid,
  });
  const { error } = response;
  const timestamp = moment();
  if (!error) {
    yield put(reservationRejected({ reservation, reservationUuid: reservation.uuid, timestamp }));
  } else {
    yield put(reservationRejectFailed({ reservationUuid: reservation.uuid, timestamp }));
  }
}

export default function* watchRejectReservationSaga() {
  yield takeEvery(rejectReservation, rejectReservationSaga);
}
